// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    AddAccount,
    AddAccountParameter,
    chain,
} from "@insite/client-framework/Store/Data/Accounts/Handlers/AddAccount";
import { TurnerUpdateAccountModel } from "@turnerBlueprint/App/Services/TurnerApiModels";
import { turnerUpdateAccount } from "@turnerBlueprint/App/Services/TurnerUpdateAccountService";

export interface TurnerAddAccountParameter extends AddAccountParameter {
    accountInfo: TurnerUpdateAccountModel;
}

addToChainAfter(chain, AddAccount, TurnerPopulateApiParameter);

async function TurnerPopulateApiParameter(props: any) {
    if (props.apiResult.successful) {
        props.apiResult = await turnerUpdateAccount(props.parameter);
    }
}
